var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header-box" }, [
    _c("div", { staticClass: "container header-content" }, [
      _c(
        "div",
        { staticClass: "header-content-box" },
        [
          _c("nuxt-link", { staticClass: "header-logo", attrs: { to: "/" } }, [
            _c("img", {
              attrs: { src: require("static/images/header_logo.png") }
            })
          ]),
          _c("div", { staticClass: "header-rihgt" }, [
            _c(
              "div",
              { staticClass: "header-nav" },
              _vm._l(_vm.menuList, function(val, key) {
                return _c(
                  "div",
                  {
                    key: key,
                    class: ["nav-item", { active: _vm.currMenu === key }]
                  },
                  [
                    _c(
                      "nuxt-link",
                      {
                        staticClass: "nav-item-title",
                        attrs: { to: val.href }
                      },
                      [
                        _vm._v(_vm._s(val.title)),
                        val.children && val.children.length
                          ? _c("i", { staticClass: "el-icon-arrow-down" })
                          : _vm._e()
                      ]
                    ),
                    val.children && val.children.length
                      ? _c("div", { staticClass: "nav-body" }, [
                          _c(
                            "div",
                            { staticClass: "container nav-content" },
                            _vm._l(val.children, function(list, ix) {
                              return _c(
                                "div",
                                { key: ix, staticClass: "nav-content-item" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "nav-content-header" },
                                    [_c("span", [_vm._v(_vm._s(list.title))])]
                                  ),
                                  _vm._l(list.children, function(nav, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "nav-content-info",
                                        class: [
                                          {
                                            actives:
                                              nav.href === _vm.$route.path
                                          }
                                        ]
                                      },
                                      [
                                        nav.icon && nav.icon !== ""
                                          ? _c("img", {
                                              attrs: { src: nav.icon, alt: "" }
                                            })
                                          : _vm._e(),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "nav-content-info-right",
                                            attrs: {
                                              href: "javascript:void(0)"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.clickItem(nav.href)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "nav-content-title"
                                              },
                                              [_vm._v(_vm._s(nav.title))]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "nav-content-text"
                                              },
                                              [_vm._v(_vm._s(nav.text))]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            }),
                            0
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              }),
              0
            ),
            _c(
              "a",
              {
                staticClass: "apply-content",
                attrs: {
                  href: "https://www.xinminghui.com/saas-apply",
                  target: "_blank"
                }
              },
              [_vm._v("免费试用")]
            )
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d2a13b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d2a13b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/layouts/main/header.vue
// module id = SMbQ
// module chunks = 1 3